import { GroupSecurity } from '@quromedical/fhir-common';
import type { PatientRouteParams } from 'app/routes';
import { PatientHeaderSection } from 'core/patient';
import { Alert, Snackbar, Tabs } from 'design-system';
import { useGlobalSearchParams } from 'expo-router';
import { useUserSession } from 'hooks';
import { usePathologyActions } from 'hooks/usePathology';
import type { PathologyStackScreenProps } from 'navigation';
import type React from 'react';
import { useEffect, useState } from 'react';
import { ScrollView } from 'react-native';
import { NotFoundScreen } from 'screens/NotFoundScreen';
import { strings } from 'strings';

import { ReportTab, RequestTab } from './tabs';

export const PathologyScreen: React.FC<
  PathologyStackScreenProps<'List'>
> = () => {
  const { patientId } = useGlobalSearchParams<PatientRouteParams>();
  const session = useUserSession();
  const pathologyActions = usePathologyActions();

  const { error } = pathologyActions;

  const [snackState, setSnackState] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      setSnackState(true);
    }
  }, [error]);

  if (!patientId) {
    return <NotFoundScreen />;
  }

  const hasPathologyRead = session.hasAny([GroupSecurity.ServiceRequestRead]);
  const hasPathologyWrite = session.hasAny([
    GroupSecurity.DiagnosticReportRead,
  ]);
  return (
    <ScrollView>
      <Snackbar
        isOpen={snackState}
        onClose={() => {
          return;
        }}
      >
        <Alert
          actionIcon="close"
          backgroundColor="status-critical"
          onAction={() => {
            setSnackState(false);
          }}
          title={strings.AlertError}
          body={error}
          icon="error"
        />
      </Snackbar>
      <PatientHeaderSection id={patientId} />
      <Tabs.Group>
        <Tabs.Screen
          isHidden={!hasPathologyRead}
          title={strings.PathologyRequestsTabTitle}
        >
          <RequestTab
            usePathologyProps={pathologyActions}
            patientId={patientId}
          />
        </Tabs.Screen>
        <Tabs.Screen
          isHidden={!hasPathologyWrite}
          title={strings.PathologyReportsTabTitle}
        >
          <ReportTab patientId={patientId} />
        </Tabs.Screen>
      </Tabs.Group>
    </ScrollView>
  );
};
